export default {
  message: {
    title:{
      HomeTitle:"库迪公链-这是一条创新的Layer2公链",
      Download:"库迪公链-这是一条创新的Layer2公链",
      AboutUs:"库迪公链-这是一条创新的Layer2公链",
      News:"库迪公链-这是一条创新的Layer2公链",
      NewsDetails:"库迪公链-这是一条创新的Layer2公链",
      Company:"库迪公链-这是一条创新的Layer2公链",
      AndroidProcess:"库迪公链-这是一条创新的Layer2公链",
      IOSProcess:"库迪公链-这是一条创新的Layer2公链",
    },
    zh:'中文简体',
    en:'英文',
    kor:'韩语',
    i18:'中文简体',
    headerMenu_home:'首页',
    headerMenu_news:'新闻',
    headerMenu_download:'下载',
    headerMenu_aboutUs:'我们',
    homeTitle1:`让数字货币\n变得随处可见`,
    homeTitle2:'用DAO来管理你的钱包，让安全与你相随。\nKuDee公链上最大的去中心化钱包。',
    Android:'安卓Android',
    Ios:'苹果IOS(超级签)',
    AndroidGeneral:'安卓Android(通用)',
    Version:'版本号',
    UpdateTime:'更新时间',
    IOSSuper:'苹果IOS(超级签)',
    homeTitle3:'我们为你的数字资产\n保驾护航',
    homeTitle4:'你的数字资产将存储在区块链网络上，每一份资产都将会受到区块链技术的保护',
    homeTitle5:'安全访问',
    homeTitle6:'资产上链，匿名化资产管理，资产安全有保障',
    homeTitle7:'交易简单',
    homeTitle8:'随时随地，让你的数字资产轻松交易，无论是转账，跨链或者其他',
    homeTitle9:'多链管理',
    homeTitle10:'轻松访问链上代币，支持KuDee,BSC,Polygon,波场等区块链网络',
    homeTitle11:'我们的最新新闻和资讯',
    homeTitle12:'我们正在全世界推广我们的区块链事业和产品，在这里我们将即时发布最新的新闻和咨询',
    homeTitle13:'让数字货币\n变得随处可见',
    homeTitle14:'*重要声明：目前KuDee钱包仅接受美国司法管辖及监督，并获得相关监管机构许可。',
    homeTitle15:'社交媒体',
    homeTitle16:'KUDEE WALLET下载地址',
    homeTitle17:'KuDee Wallet是一款支持多链的自托管钱包，使用简单安全，深受全球数千万人的信赖与喜爱。',
    homeTitle18:'*请务必从官网下载钱包应用，并检查网站的SSL证书',
    homeTitle19:'*请勿相信他人借用账号和密码行为',
    homeTitle20:'*用户资产均在链上，请妥善保管好相关凭证信息',
    homeTitle21:'*保护好您的私钥，助记词，切勿泄露，更不可与任何人透露',
    homeTitle22:'*了解更多安全知识',
    homeTitle23:'最新版本',
    homeTitle24:'如何验证钱包App的真假？',
    AboutUsTitle1:'关于我们',
    AboutUsTitle2:'在这里，你可以快速找到我们',
    AboutUsTitle3:'公司信息',
    AboutUsTitle4:'我们在多个国家和地区均有注册，我们一直致力于合法合规的运营。',
    AboutUsTitle5:'1.澳大利亚总部：全球化战略运营中心',
    AboutUsTitle6:'2.美国分公司：代币运营与合规管理',
    AboutUsTitle7:'3.英国分公司：全球技术支持与研发支持',
    AboutUsTitle8:'4.加拿大公司：全球节点运营和维护中心',
    AboutUsTitle9:'*点击此处查询公司信息详情。',
    AboutUsTitle10:'你可以通过以下方式联系我们并寻求商务合作。',
    AboutUsTitle11:'官方媒体',
    homeTitle25:'获取谷歌验证器',
    News1title:'KuDee公链正式立项，进军公链领域',
    News1time:'2024年2月',
    News1Introduction:'公司核心开发成员来自Google，微软，币安等互联网企业，开发经验丰富。',
    News2title:"KuDee公链团队推出公链生态系列产品",
    News2time:'2024年12月',
    News2Introduction:'推出KuEX App，KuDee公链浏览器等核心生态产品。',
    News3title:'KuEX APP正式启动并整合多个新功能',
    News3time:'2025年1月-3月',
    News3Introduction:'KuEX App包含钱包、DAPP、交易所、社交和娱乐功能。',

    Process1:'用一条公链，创造无数奇迹！',
    Process2:'Android下载',
    Process3:'Iphone下载',
    Process4:'下滑查看教程',
    Process5:'操作流程',
    Process6:'点击“下载”按钮',
    Process7:'点击“下载安装”',
    Process8:'点击“安装”',
    Process9:'点击“立即信任”',
    Process10:'点击“允许”',
    Process11:'点击“信任此应用”',
    Process12:'点击“信任MOST INC EOOD”',
    Process13:'点击“信任”此应用',
    Process14:'用区块链技术打造更美好的金融世界',
  }
}
